import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const finn = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      layout: {
        backText: "Zurück zu finn.com",
      },
      garageList: {
        emptyState: {
          headline: "Keine buchbare Werkstatt in Ihrer Nähe",
          description:
            "Erweitern Sie den Suchradius oder passen Sie Ihre Filter an. Wird weiterhin keine " +
            "Werkstatt gefunden, können Sie Ihren Werkstattauftrag direkt über FINN anfragen.",
          finnCtaLabel: "Werkstattauftrag über FINN anfragen",
        },
      },
      blockingModal: {
        title: "Buchung nur über Ihren FINN-Account möglich",
        text: 'Bitte buchen Sie Ihren Servicetermin direkt über Ihren FINN-Account unter "Schäden & Services".',
        linkLabel: "Zurück zu finn.com",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/finn",
      homeHints: {
        tesla:
          "Bitte setzen Sie sich über die Tesla-App direkt mit einem Tesla-Servicepunkt in Verbindung, um einen Termin zu vereinbaren.",
        MG: `Für die Marke MG gibt es aktuell keine verfügbaren Werkstätten, bitte wenden Sie sich direkt an FINN. <a href="tel:+089143770064">+49 (0) 89 143 770 064</a>`,
        searchTestCenter: "Prüfstelle suchen",
      },
    },
  },
};
